import type { AtlasContentEditorOptions } from "@resource/atlas";
import { fixedToolbarModule } from "@resource/atlas/content-editor/fixed-toolbar";
import { lineActionsModule } from "@resource/atlas/content-editor/line-actions";
import { richQuoteModule } from "@resource/atlas/content-editor/rich-quote";
import { videoModule } from "@resource/atlas/content-editor/video";
import { useFlags } from "@resource/client-ffs";
import { useFileModule } from "client/guide-content/rich-blocks/file";
import { gifModule } from "client/guide-content/rich-blocks/gif";
import { useImageModule } from "client/guide-content/rich-blocks/image";
import FeatureFlags from "generated/FeatureFlags";

export function useBaseModules() {
  const modules: AtlasContentEditorOptions["modules"] = [
    useImageModule(),
    videoModule,
    richQuoteModule,
    fixedToolbarModule,
  ];

  const {
    [FeatureFlags.FILE_UPLOAD]: fileUploadEnabled,
    [FeatureFlags.EDITOR_LINE_ACTIONS]: lineActionsEnabled,
    [FeatureFlags.CONTENT_EDITOR_GIFS]: gifsEnabled,
  } = useFlags();

  const fileModule = useFileModule();

  if (fileUploadEnabled) modules.push(fileModule);
  if (lineActionsEnabled) modules.push(lineActionsModule);
  if (gifsEnabled) modules.push(gifModule);

  return modules;
}
